import { BaseActionWithNav } from "./BaseActionWithNav";
import { Switchboard } from "../../lib/events";
export class AddBuildingsAction extends BaseActionWithNav {
    constructor(layer, p_layer) {
        super('ADD BUILDINGS');
        this.layer = layer;
        this.p_layer = p_layer;
        this.interaction = '';
        this.emitter = Switchboard.get_emitter("INTERACTION");
        this.interaction = 'bld_move';
        this.emitter.emit('i_req_revert', this.interaction);
    }
    validate(message) {
        return super.validate(message) && message.buildings.length > 0;
    }
    on_valid_message() { }
    async interpret(message) {
        this.layer.clear();
        if (message.geocoded) {
            return this.layer.add_from_json(message.buildings);
        }
        let buildings = JSON.parse(message.buildings);
        let maybe_centroid = await this.p_layer.get_feature_center_by_id(message.strap);
        if (maybe_centroid.isSome()) {
            const centroid = maybe_centroid.unwrap();
            for (let bld of buildings)
                this.layer.add_at_centroid(bld.rings, centroid, bld.attributes);
        }
    }
}
